module.exports = __webpack_public_path__ + "a768e7de/img/lock-icon.bb9c7166.svg";